module.exports = __webpack_public_path__ + "static/media/systems.004fe512.png";